import React, { useState } from 'react';
import './imageUpload.css';

const ImageUpload = () => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [location, setLocation] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
    setResult(null);
  };

  const handleSubmit = async () => {
    if (!image || !location || !date || !time) {
      alert('Please fill in all fields and upload an image.');
      return;
    }

    const formData = new FormData();
    formData.append('image', image);

    setLoading(true);
    try {
      const response = await fetch('https://crisisvision-ai-backend.uc.r.appspot.com/predict', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      setResult({
        fireDetected: data.fire_detected,
        detections: data.detections,
      });

      // OPTIONAL: Later, you can send this verified result + metadata to your Node backend here

    } catch (err) {
      console.error('Error submitting image:', err);
      alert('Failed to get prediction');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-container">
      <h3>📸 Upload Image for Fire Detection</h3>

      <input type="file" accept="image/*" onChange={handleImageChange} className="file-input" />

      {preview && (
        <div className="preview-block">
          <img src={preview} alt="Preview" className="image-preview" />
        </div>
      )}

      <div className="form-group">
        <input
          type="text"
          placeholder="Location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <input
          type="time"
          value={time}
          onChange={(e) => setTime(e.target.value)}
        />
      </div>

      {image && !loading ? (
        <button className="submit-button" onClick={handleSubmit}>
          Submit
        </button>
      ) : (
        <button className="upload-button" disabled>
          Upload
        </button>
      )}

      {loading && <p className="loader">⏳ Detecting...</p>}

      {result && (
        <div className="result-box">
          <p>🔥 Fire Detected: {result.fireDetected ? 'Yes' : 'No'}</p>
          <ul>
            {result.detections.length > 0 ? (
              result.detections.map((d, i) => (
                <li key={i}>
                  {d.label} — Confidence: {d.confidence}
                </li>
              ))
            ) : (
              <li>No confident detections</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
